const pressShiftDeleteDragDeal = {
    title: 'Подсказка',
    description:
        'При перетаскивании сделки зажмите клавишу <b>Shift</b>, чтобы удалить её. Удалять можно только <b>незавершённые</b> сделки',
    buttonText: 'Всё понятно!',
    mode: 'support',
} as const;

export default pressShiftDeleteDragDeal;
